/**
 * Deprecated
 * Use simple radio-button css class
 * Example:
 * `
 * <div class="radio-button-group">
 *    <label class="radio-button">
 *        <input type="radio"
 *               [value]="0"
 *               [name]="'radioName'"/>
 *        <div>Some option</div>
 *    </label>
 *    <label class="radio-button">
 *        <input type="radio"
 *               [value]="2"
 *               [name]="'radioName'"/>
 *        <div>Another option</div>
 *    </label>
 * </div>
 * `
 * */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import get from 'lodash/get';

@Component({
  standalone: false,
  selector: 'ui-radio-group',
  templateUrl: './ui-radio-group.component.html',
  styleUrls: ['./ui-radio-group.component.scss']
})
export class UiRadioGroupComponent {
  public selectedItem: { id: string, label: string };

  @Input() public items: { id: string, label: string }[];
  @Output() public modelChange = new EventEmitter<{ id: string, label: string }>();

  @Input()
  public get model() {
    return this.selectedItem;
  }

  public set model(selectedItem: any) {
    const isChanged = get(this.selectedItem, 'id') !== get(selectedItem, 'id');

    this.selectedItem = selectedItem;
    if (isChanged) {
      this.modelChange.emit(selectedItem);
    }
  }
}
